function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={`wl-skeleton ${className || ""}`}
      {...props}
    />
  );
}

export { Skeleton };
